import React from 'react';
import { Modal, Spin, Alert } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { CLEAR_ERRORS } from '../../state/error/types';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const ModalCancelContract = ({ ...props }) => {
  return (
    <Modal
      visible={props.visible}
      title="Anular contrato de arriendo"
      okText="Anular"
      cancelText="Cancelar"
      maskClosable={false}
      onCancel={props.onCancel}
      afterClose={() => props.clearErrors()}
      onOk={() => props.onCreate()}
      okButtonProps={{ disabled: props.spinning }}
      cancelButtonProps={{ disabled: props.spinning }}
    >
      <Spin
        spinning={props.spinning}
        size="large"
        indicator={spinnerIcon}
      >
        <Alert
          message="Está a punto de anular el contrato"
          description="Esta accioón eliminará el contrato de los registros de manera irreversible. ¿Está seguro que desea continuar?"
          type="warning"
          showIcon
        />
      </Spin>
    </Modal>
  );
};

ModalCancelContract.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  spinning: PropTypes.bool.isRequired,
  spinnerIcon: PropTypes.object,
};

const action = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalCancelContract);